<div
  #valueSelectContainer
  class="multiple-values-selector-container"
  [ngStyle]="{ width: setWidth, 'max-width': maxWidth }"
  >
  <div
    tabindex="0"
    class="value-selector-selected-container"
    [ngClass]="{ disabled: disabled }"
    (click)="this.setSelectingValueOptions()"
    (keydown)="keyHandler($event)"
    [attr.aria-controls]="elementId"
    role="listbox"
    >
    <p
      class="value-selector-option currentSelection-p"
      [ngClass]="{ disabled: disabled }"
      >
      {{ getCurrentSelectionName() }}
    </p>
    <mat-icon
      class="value-selector-arrow currentSelection-i"
      [ngClass]="{ disabled: disabled }"
      >keyboard_arrow_down</mat-icon
      >
    </div>
    @if (showOptions()) {
      <div
        class="value-selector-options"
        [attr.id]="elementId"
        [ngStyle]="maxHeightReturn()"
        [ngClass]="{ goUp: !extendDown }"
        >
        @for (option of valueList; track option; let i = $index) {
          <p
            class="value-selector-option"
            [ngClass]="{
                'selected-option': option.id === currentTabbedSelection.id
            }"
            (click)="setCurrentSelection(option, i)"
            >
            <span class="value-selector-checkbox-container"
              >@if (i !== 0) {
              <input
                class="value-selector-checkbox-input"
                type="checkbox"
                [checked]="option.checked"
                [value]="option.id"
                (change)="onValueListSelectToggle($event)"
                />
            }
            <span (click)="onSelectValueRowClick(option)">{{
              option?.value
            }}</span>
          </span>
        </p>
      }
    </div>
  }
</div>
